import { useEffect, useMemo, useRef, useState } from "react";
import type { Dispatch, SetStateAction } from "react";

import {
  filtersMetaToOptions,
  type ReportingSummaryFiltersValue,
} from "../../../queries/sportsbook/reportingSummaryFilterOptions";
import type { SportsbookAnalyticsFilterMetaDto } from "../../../queries/sportsbook/sportsbookAnalyticsFilterParams";

export function useProfitabilitySectionFilterState(
  inheritedFilters: ReportingSummaryFiltersValue,
) {
  const [filters, setFilters] =
    useState<ReportingSummaryFiltersValue>(inheritedFilters);
  return {
    filters,
    setFilters,
    setBetType: (bet_type: string[]) =>
      setFilters((current) => ({ ...current, bet_type })),
    setMoneyType: (money_type: string[]) =>
      setFilters((current) => ({ ...current, money_type })),
  };
}

export function useProfitabilityFilterOptions(
  meta: SportsbookAnalyticsFilterMetaDto[],
  setFilters: Dispatch<SetStateAction<ReportingSummaryFiltersValue>>,
  date: string,
) {
  const seededForDate = useRef<string | null>(null);
  const options = useMemo(() => filtersMetaToOptions(meta), [meta]);

  useEffect(() => {
    if (!options || seededForDate.current === date) return;
    seededForDate.current = date;
    setFilters((current) => ({
      ...current,
      money_type:
        current.money_type.length > 0
          ? current.money_type
          : options.money_type.defaultSelected,
      bet_type:
        current.bet_type.length > 0
          ? current.bet_type
          : options.bet_type.defaultSelected,
    }));
  }, [date, options, setFilters]);

  return options;
}
